/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateHomeIFrameUrlRequest
 */
export interface OmniGenerateHomeIFrameUrlRequest {
    /**
     * 
     */
    facility_type: OmniGenerateHomeIFrameUrlRequestFacilityTypeEnum;
    /**
     * 
     */
    user_timezone?: string;
}


/**
 * @export
 */
export const OmniGenerateHomeIFrameUrlRequestFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type OmniGenerateHomeIFrameUrlRequestFacilityTypeEnum = typeof OmniGenerateHomeIFrameUrlRequestFacilityTypeEnum[keyof typeof OmniGenerateHomeIFrameUrlRequestFacilityTypeEnum];


/**
 * Check if a given object implements the OmniGenerateHomeIFrameUrlRequest interface.
 */
export function instanceOfOmniGenerateHomeIFrameUrlRequest(value: object): value is OmniGenerateHomeIFrameUrlRequest {
    if (!('facility_type' in value) || value['facility_type'] === undefined) return false;
    return true;
}

export function OmniGenerateHomeIFrameUrlRequestFromJSON(json: any): OmniGenerateHomeIFrameUrlRequest {
    return OmniGenerateHomeIFrameUrlRequestFromJSONTyped(json, false);
}

export function OmniGenerateHomeIFrameUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateHomeIFrameUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_type': json['facility_type'],
        'user_timezone': json['user_timezone'] == null ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateHomeIFrameUrlRequestToJSON(json: any): OmniGenerateHomeIFrameUrlRequest {
    return OmniGenerateHomeIFrameUrlRequestToJSONTyped(json, false);
}

export function OmniGenerateHomeIFrameUrlRequestToJSONTyped(value?: OmniGenerateHomeIFrameUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_type': value['facility_type'],
        'user_timezone': value['user_timezone'],
    };
}

